import { motion } from "framer-motion";
import { HeartHandshake, Rocket, GraduationCap, LifeBuoy, ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useDemo } from "../context/DemoContext";
import Seo from "../components/Seo";
import { PAGE_SEO } from "../lib/seo";

const meta = [
  { icon: HeartHandshake, color: "#F05A28" },
  { icon: Rocket, color: "#F7931D" },
  { icon: GraduationCap, color: "#4BB5E7" },
  { icon: LifeBuoy, color: "#3AAA35" },
];

export default function Support() {
  const { openDemo } = useDemo();
  const { t } = useTranslation();
  const pillars = t("supportPage.pillars", { returnObjects: true });
  return (
    <div data-testid="support-page" className="pt-32 md:pt-40">
      <Seo {...PAGE_SEO["/support"]} path="/support" />
      <section className="max-w-7xl mx-auto px-4 md:px-8 pb-16">
        <p className="uppercase tracking-[0.25em] text-xs font-bold text-joyn-green mb-4">{t("supportPage.eyebrow")}</p>
        <h1 className="font-display font-extrabold text-5xl md:text-6xl tracking-tight leading-[0.98] max-w-4xl">{t("supportPage.titleBefore")}<span className="joyn-gradient-text">{t("supportPage.titleBrand")}</span></h1>
        <p className="mt-5 text-lg text-muted-foreground max-w-2xl">{t("supportPage.desc")}</p>
      </section>

      <section className="max-w-7xl mx-auto px-4 md:px-8 pb-24">
        <div className="grid md:grid-cols-2 gap-6">
          {pillars.map((p, i) => {
            const Icon = meta[i].icon;
            return (
              <motion.div key={i} initial={{ opacity: 0, y: 22 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: (i % 2) * 0.08, duration: 0.45 }}
                className="bg-card border border-border rounded-3xl p-8 md:p-10 hover:shadow-lg transition-shadow">
                <span className="inline-flex h-14 w-14 items-center justify-center rounded-2xl text-white mb-6" style={{ background: meta[i].color }}><Icon size={26} /></span>
                <h2 className="font-display font-extrabold text-2xl tracking-tight mb-3">{p.t}</h2>
                <p className="text-muted-foreground leading-relaxed">{p.b}</p>
              </motion.div>
            );
          })}
        </div>
      </section>

      <section className="bg-secondary/50 border-y border-border">
        <div className="max-w-5xl mx-auto px-4 md:px-8 py-20 text-center">
          <p className="font-display font-extrabold text-3xl md:text-4xl tracking-tight leading-snug">“{t("supportPage.quote")}”</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 md:px-8 py-24">
        <div className="rounded-3xl bg-foreground text-white p-10 md:p-16 text-center relative overflow-hidden">
          <div className="h-1.5 joyn-gradient-bar absolute top-0 inset-x-0" />
          <h2 className="font-display font-extrabold text-3xl md:text-4xl tracking-tight mb-4">{t("supportPage.ctaTitle")}</h2>
          <button data-testid="support-demo-btn" onClick={openDemo} className="mt-4 inline-flex items-center gap-2 bg-white text-foreground font-semibold px-8 py-4 rounded-full hover:-translate-y-1 transition-transform">{t("nav.demo")} <ArrowRight size={18} /></button>
        </div>
      </section>
    </div>
  );
}
